/**
 * Scroll Reveal — Lightweight IntersectionObserver animation system.
 * Adds `.is-visible` to `.reveal` elements as they enter the viewport.
 * Supports `data-reveal-delay="100"` for staggered timing on grid children.
 * Respects `prefers-reduced-motion`.
 */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('.reveal').forEach(function (el) {
      el.classList.add('is-visible');
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          var delay = parseInt(el.getAttribute('data-reveal-delay'), 10) || 0;
          if (delay > 0) {
            setTimeout(function () {
              el.classList.add('is-visible');
            }, delay);
          } else {
            el.classList.add('is-visible');
          }
          observer.unobserve(el);
        }
      });
    },
    { threshold: 0.15 }
  );

  document.querySelectorAll('.reveal').forEach(function (el) {
    observer.observe(el);
  });
})();
